var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.0559C0 15.0279 3.61111 19.162 8.33333 20L8.38896 19.9552C8.37042 19.9516 8.35188 19.948 8.33334 19.9442V12.8493H5.83334V10.056H8.33334V7.82134C8.33334 5.30737 9.94445 3.91073 12.2222 3.91073C12.9444 3.91073 13.7222 4.02246 14.4444 4.13419V6.70402H13.1667C11.9444 6.70402 11.6667 7.31854 11.6667 8.10067V10.056H14.3333L13.8889 12.8493H11.6667V19.9442C11.6481 19.948 11.6296 19.9516 11.611 19.9552L11.6667 20C16.3889 19.162 20 15.0279 20 10.0559C20 4.52513 15.5 0 10 0C4.5 0 0 4.52513 0 10.0559Z",
    fill: "#FF7010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/Subtract.c5233a4fcf4daafe61a16efb2a2e9a46.svg";
export { ForwardRef as ReactComponent };